import SupervisionIndex from '../views/Supervision/Index'

const routes = {
    path: '/supervision',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/supervision',
            name: 'supervision',
            component: SupervisionIndex,
            meta: {
                pageTitle: 'supervision.title',
                access_nivel: ['1', '2', '3'],
                breadcrumb: [
                    { text: 'supervision.title', active: true },
                ],
            },
        },
    ],
}

export default routes
